import { AgGridTable, type AgGridTableProps } from '@shared/components/ui/AgGridTable';
import type { ColDef, GetRowIdParams } from 'ag-grid-community';
import { useMemo } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import type { LegacyDashboardClient } from '../../models/LegacyDashboardClient';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

interface TableProps {
  clients: LegacyDashboardClient[];
  isLoading?: boolean;
  isFetching?: boolean;
  sorting?: SortingConfig | null;
  onSortingChange?: (sorting: SortingConfig | null) => void;
  onViewSgaProducts?: (client: LegacyDashboardClient) => void;
}

export const LegacyDashboardTable = ({
  clients,
  isLoading = false,
  isFetching = false,
  sorting,
  onSortingChange,
  onViewSgaProducts,
}: TableProps) => {
  const { allColumnDefs } = useAgGridColumns(onViewSgaProducts);
  const columnDefs = useMemo<ColDef<LegacyDashboardClient>[]>(() => allColumnDefs, [allColumnDefs]);

  const gridOptions = useMemo(
    () => ({
      getRowId: (params: GetRowIdParams<LegacyDashboardClient>) =>
        String(params.data?.legacy_team_id ?? params.data?.name),
    }),
    [],
  );

  return (
    <div className={`w-full transition-opacity duration-300 ${isFetching ? 'opacity-50 pointer-events-none' : ''}`}>
      <AgGridTable
        data={clients}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        className="rounded-lg shadow-sm"
        height="calc(100vh - 280px)"
        rowHeight={52}
        isLoading={isLoading}
        sorting={sorting}
        onSortingChange={onSortingChange}
        suppressCellFocus={true}
      />
    </div>
  );
};
